export const CAR_IMAGE_WALKAROUND_KEYS = [
    "front",
    "frontRight",
    "rightSide",
    "rearRight",
    "rear",
    "rearLeft",
    "leftSide",
    "frontLeft",
];

export const CAR_IMAGE_DAMAGE_KEYS = ["damage1", "damage2", "damage3", "damage4", "damage5"];

export const CAR_IMAGE_OPTIONAL_KEYS = [...CAR_IMAGE_WALKAROUND_KEYS, "dashboard", ...CAR_IMAGE_DAMAGE_KEYS];

export const compactCarImages = (source) => {
    if (!source) return {};

    const compact = {};
    CAR_IMAGE_OPTIONAL_KEYS.forEach((key) => {
        const value = source[key];
        if (value) compact[key] = value;
    });
    return compact;
};
